import { RouteInfo } from "./vertical-menu.metadata";
import { Roles } from "app/roles";

const {
  ADMIN,
  MANAGER,
  CREATOR,
  RIGHT_HOLDER,
  MANAGER_LIMITED,
  VIEWER,
  VIEWER_LIMITED,
  RIGHT_HOLDER_TEAM,
  CREATOR_TEAM,
  TRUE_SUPER_CONTENT_OWNER
} = Roles;

//Sidebar menu Routes and data
export const ROUTES: RouteInfo[] = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: "ft-home",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
    hasaccess: [CREATOR],
  },
  {
    path: "/dashboard/analytics",
    title: "Dashboard",
    icon: "ft-home",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
    hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, RIGHT_HOLDER, VIEWER_LIMITED, TRUE_SUPER_CONTENT_OWNER],
  },
  {
    path: "/creators/profile",
    title: "Profile",
    icon: "ft-user",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
    hasaccess: [CREATOR, CREATOR_TEAM],
  },
  {
    path: "/right-holders/profile",
    title: "Profile",
    icon: "ft-user",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
    hasaccess: [RIGHT_HOLDER, RIGHT_HOLDER_TEAM, TRUE_SUPER_CONTENT_OWNER],
  },
  {
    path: "/team-members",
    title: "Team Members",
    icon: "ft-users",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
    hasaccess: [CREATOR],
  },
  {
    path: "/",
    title: "Asset Labels",
    icon: "ft-users",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
    hasaccess: [TRUE_SUPER_CONTENT_OWNER],
  },
  {
    path: "/admins",
    title: "Admin",
    icon: "ft-user",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
    hasaccess: [ADMIN],
  },
  {
    path: "",
    title: "Accounts",
    icon: "ft-users",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
    submenu: [
      {
        path: "/super-right-holders",
        title: "Rights Holders",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
      },
      {
        path: "/creators",
        title: "Creators / Channel Owners",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
      }
    ],
  },
  {
    path: "",
    title: "Agreements",
    icon: "ft-clipboard",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
    submenu: [
      {
        path: "/claim-contracts",
        title: "Claims",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
      },
      {
        path: "/contracts",
        title: "Sublicensing",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
      }
    ],
  },
  {
    path: "",
    title: "Upload",
    icon: "ft-upload",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED, RIGHT_HOLDER, RIGHT_HOLDER_TEAM],
    submenu: [
      {
        path: "/upload",
        title: "Upload Content",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        hasaccess: [
          ADMIN,
          MANAGER,
          MANAGER_LIMITED,
          VIEWER,
          VIEWER_LIMITED,
          RIGHT_HOLDER,
          RIGHT_HOLDER_TEAM,
        ],
        submenu: [],
      },
      {
        path: "assets/pending-review",
        title: "Uploads Pending Review",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED, RIGHT_HOLDER, RIGHT_HOLDER_TEAM],
      },
      {
        path: "assets/draft-asset",
        title: "Upload Drafts",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [
          ADMIN,
          MANAGER,
          MANAGER_LIMITED,
          VIEWER,
          VIEWER_LIMITED,
          RIGHT_HOLDER,
          RIGHT_HOLDER_TEAM,
        ],
      },
      {
        path: "/auto-sync",
        title: "Auto Sync",
        icon: "ft-refresh-cw submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        hasaccess: [
          ADMIN,
          MANAGER,
          MANAGER_LIMITED,
          VIEWER,
          VIEWER_LIMITED
        ],
        submenu: [],
      }
    ],
  },

  {
    path: "",
    title: "Content",
    icon: "ft-play",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [
      {
        path: "/libraries",
        title: "Content Library",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED, RIGHT_HOLDER, RIGHT_HOLDER_TEAM],
      },
      {
        path: "/discover",
        title: "Discover",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "Beta",
        badgeClass: "badge badge-pill beta_badge float-right mr-1 mt-1",
        isExternalLink: false,
        submenu: [],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
      },
      {
        path: "",
        title: "Content Settings",
        icon: "ft-arrow-right submenu-icon",
        class: "has-sub",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [
          {
            path: "/artists",
            title: "Speakers",
            icon: "ft-arrow-right submenu-icon",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
            hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
          },
          {
            path: "/categories",
            title: "Category Settings",
            icon: "ft-arrow-right submenu-icon",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
            hasaccess: [
              ADMIN,
              MANAGER,
              MANAGER_LIMITED,
              VIEWER,
              VIEWER_LIMITED,
            ],
          },
          {
            path: "/energy-level",
            title: "Energy Level Settings",
            icon: "ft-arrow-right submenu-icon",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
            hasaccess: [
              ADMIN,
              MANAGER,
              MANAGER_LIMITED,
              VIEWER,
              VIEWER_LIMITED,
            ],
          },

        ],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
      }

    ],
    hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
  },

  {
    path: "",
    title: "Content",
    icon: "ft-play",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [
      {
        path: "/libraries",
        title: "Content Library",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [RIGHT_HOLDER, RIGHT_HOLDER_TEAM],
      },
      {
        path: "/discover",
        title: "Discover",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "Beta",
        badgeClass: "badge badge-pill beta_badge float-right mr-1 mt-1",
        isExternalLink: false,
        submenu: [],
        hasaccess: [RIGHT_HOLDER, RIGHT_HOLDER_TEAM],
      },
    ],
    hasaccess: [RIGHT_HOLDER, RIGHT_HOLDER_TEAM],
  },

  {
    path: "/libraries",
    title: "Content",
    icon: "ft-play",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
    hasaccess: [TRUE_SUPER_CONTENT_OWNER],
  },

  {
    path: "/contracts",
    title: "Your Agreements",
    icon: "ft-users",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    hasaccess: [CREATOR, CREATOR_TEAM],
    submenu: [],
  },

  {
    path: "",
    title: "YouTube Claims",
    icon: "ft-shield",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [
      {
        path: "assets/claim-video",
        title: "Claimed Videos",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [
          ADMIN,
          MANAGER,
          MANAGER_LIMITED,
          VIEWER,
          VIEWER_LIMITED,
          CREATOR,
          RIGHT_HOLDER,
          RIGHT_HOLDER_TEAM,
          TRUE_SUPER_CONTENT_OWNER
        ],
      },

      {
        path: "assets/manual-claiming",
        title: "Manual Claiming",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [
          ADMIN,
          MANAGER,
          MANAGER_LIMITED,
          VIEWER,
          VIEWER_LIMITED,
          RIGHT_HOLDER,
          RIGHT_HOLDER_TEAM,
        ],
      },
      {
        path: "assets/copyright-takedown",
        title: "Copyright Takedown",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [
          ADMIN,
          MANAGER,
          MANAGER_LIMITED,
          VIEWER,
          VIEWER_LIMITED,
          RIGHT_HOLDER,
          RIGHT_HOLDER_TEAM,
        ],
      },
      // {
      //   path: "ai-content-removal",
      //   title: "AI Content Removal",
      //   icon: "ft-arrow-right submenu-icon",
      //   class: "",
      //   badge: "",
      //   badgeClass: "",
      //   isExternalLink: false,
      //   submenu: [],
      //   hasaccess: [
      //     ADMIN,
      //     MANAGER,
      //     MANAGER_LIMITED,
      //     VIEWER,
      //     VIEWER_LIMITED,
      //     RIGHT_HOLDER,
      //     RIGHT_HOLDER_TEAM,
      //   ],
      // },
      {
        path: "allow-list",
        title: "Allowlist",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [
          ADMIN,
          MANAGER,
          MANAGER_LIMITED,
          VIEWER,
          VIEWER_LIMITED,
          RIGHT_HOLDER,
          RIGHT_HOLDER_TEAM,
        ],
      },
    ],
    hasaccess: [
      ADMIN,
      MANAGER,
      MANAGER_LIMITED,
      VIEWER,
      VIEWER_LIMITED,
      RIGHT_HOLDER,
      RIGHT_HOLDER_TEAM,
      TRUE_SUPER_CONTENT_OWNER
    ],
  },

  {
    path: "/block-ai",
    title: "Block AI",
    icon: "ft-eye-off",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
    hasaccess: [
      ADMIN,
      MANAGER,
      MANAGER_LIMITED,
      VIEWER,
      VIEWER_LIMITED,
      RIGHT_HOLDER
    ],
  },

  {
    path: "",
    title: "YouTube Licensing",
    icon: "ft-video",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [
      {
        path: "/channels",
        title: "Channels",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [
          ADMIN,
          MANAGER,
          MANAGER_LIMITED,
          VIEWER,
          VIEWER_LIMITED,
          CREATOR,
          RIGHT_HOLDER,
        ],
      },
      {
        path: "/drm-youtube-videos",
        title: "DRM YouTube Videos",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [
          ADMIN,
          MANAGER,
          MANAGER_LIMITED,
          VIEWER,
          VIEWER_LIMITED,
          CREATOR,
          RIGHT_HOLDER,
        ],
      },
      {
        path: "/prospective-youtube-videos",
        title: "Prospective Sublicensee Creators",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [
          ADMIN,
          MANAGER,
          MANAGER_LIMITED,
          VIEWER,
          VIEWER_LIMITED,
          CREATOR,
          RIGHT_HOLDER,
        ],
      },
    ],
    hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
  },

  {
    path: "",
    title: "Content",
    icon: "ft-play",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [
      {
        path: "/browse",
        title: "Content Library",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [CREATOR, CREATOR_TEAM],
      },
      {
        path: "/discover",
        title: "Discover",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "Beta",
        badgeClass: "badge badge-pill beta_badge float-right mr-1 mt-1",
        isExternalLink: false,
        submenu: [],
        hasaccess: [CREATOR, CREATOR_TEAM],
      },
    ],
    hasaccess: [CREATOR, CREATOR_TEAM],
  },

  {
    path: "",
    title: "YouTube Licensing",
    icon: "ft-video",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [
      //{
      //  path: "/browse",
      //  title: "Licensing Library",
      //  icon: "ft-arrow-right submenu-icon",
      //  class: "",
      //  badge: "",
      //  badgeClass: "",
      //  isExternalLink: false,
      //  submenu: [],
      //  hasaccess: [CREATOR, CREATOR_TEAM],
      //},
      {
        path: "/channels",
        title: "Channels",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [CREATOR, CREATOR_TEAM],
      },
      {
        path: "/channels",
        title: "Sublicensee Channels",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [RIGHT_HOLDER, RIGHT_HOLDER, RIGHT_HOLDER_TEAM, TRUE_SUPER_CONTENT_OWNER],
      },
      {
        path: "/drm-youtube-videos",
        title: "DRM YouTube Videos",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [CREATOR, CREATOR_TEAM],
      },
      {
        path: "/drm-youtube-videos",
        title: "Sublicensee Videos",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [RIGHT_HOLDER, RIGHT_HOLDER_TEAM, TRUE_SUPER_CONTENT_OWNER],
      },
      {
        path: "/sublicensee-creators",
        title: "Sublicensee Creators",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [RIGHT_HOLDER, RIGHT_HOLDER_TEAM, TRUE_SUPER_CONTENT_OWNER],
      },
    ],
    hasaccess: [CREATOR, RIGHT_HOLDER, RIGHT_HOLDER_TEAM, CREATOR_TEAM, TRUE_SUPER_CONTENT_OWNER],
  },

  {
    path: "",
    title: "Payments",
    icon: "ft-dollar-sign",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [
      {
        path: "/payment-setting",
        title: "Payment Setting",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED],
      },
      {
        path: "",
        title: "Sublicensing Payment Details",
        icon: "ft-arrow-right submenu-icon",
        class: "has-sub",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [
          {
            path: "payment-history/landing-page",
            title: "Overview",
            icon: "ft-arrow-right submenu-icon",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
            hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED],
          },
          {
            path: "payment-history/by-creator",
            title: "By Creators",
            icon: "ft-arrow-right submenu-icon",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
            hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED],
          },
          {
            path: "payment-history/by-channel",
            title: "By Channel",
            icon: "ft-arrow-right submenu-icon",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
            hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED],
          },
          {
            path: "payment-history/by-right-holders",
            title: "By Content Owners",
            icon: "ft-arrow-right submenu-icon",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
            hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED],
          },
          {
            path: "payment-history/by-videos",
            title: "By YouTube videos",
            icon: "ft-arrow-right submenu-icon",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
            hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED],
          },
          {
            path: "payment-history/by-content-library",
            title: "By Asset",
            icon: "ft-arrow-right submenu-icon",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
            hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED],
          },
        ],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED],
      },
      {
        path: "claim-detail/overview",
        title: "Claims Payment Details",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED],
      },
    ],
    hasaccess: [ADMIN, MANAGER],
  },

  {
    path: "",
    title: "Payments",
    icon: "ft-dollar-sign",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [
      {
        path: "",
        title: "Sublicensing Payment Details",
        icon: "ft-arrow-right submenu-icon",
        class: "has-sub",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [
          {
            path: "payment-history/landing-page",
            title: "Overview",
            icon: "ft-arrow-right submenu-icon",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
            hasaccess: [CREATOR, RIGHT_HOLDER],
          },
          {
            path: "payment-history/by-channel",
            title: "By Channel",
            icon: "ft-arrow-right submenu-icon",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
            hasaccess: [RIGHT_HOLDER],
          },
        ],
        hasaccess: [CREATOR, RIGHT_HOLDER],
      },
      {
        path: "",
        title: "Claims Payment Details",
        icon: "ft-arrow-right submenu-icon",
        class: "has-sub",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [
          {
            path: "claim-detail/overview",
            title: "Overview",
            icon: "ft-arrow-right submenu-icon",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
            hasaccess: [RIGHT_HOLDER],
          },
        ],
        hasaccess: [RIGHT_HOLDER],
      },
    ],
    hasaccess: [CREATOR],
  },

  {
    path: "",
    title: "Payments",
    icon: "ft-dollar-sign",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [
      {
        path: "payment-history/landing-page",
        title: "Sublicensing Payment Details",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [
        ],
        hasaccess: [RIGHT_HOLDER, TRUE_SUPER_CONTENT_OWNER],
      },
      {
        path: "claim-detail/overview",
        title: "Claims Payment Details",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [
        ],
        hasaccess: [RIGHT_HOLDER, TRUE_SUPER_CONTENT_OWNER],
      },
    ],
    hasaccess: [RIGHT_HOLDER, TRUE_SUPER_CONTENT_OWNER],
  },

  //{
  //  path: "/claim-detail/overview",
  //  title: "Claims Payment",
  //  icon: "ft-dollar-sign",
  //  class: "",
  //  badge: "",
  //  badgeClass: "",
  //  isExternalLink: false,
  //  submenu: [],
  //  hasaccess: [TRUE_SUPER_CONTENT_OWNER],
  //},

  {
    path: "",
    title: "Communication",
    icon: "ft-mail",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [
      {
        path: "/inquiry-list",
        title: "Pending Requests",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
      },
      {
        path: "/contact-us",
        title: "Contact Us",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
      },
      {
        path: "/dashboard-notification",
        title: "Dashboard Notifications",
        icon: "ft-arrow-right submenu-icon",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
      }
    ],
    hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
  },

  {
    path: "/activity-log-reports",
    title: "Activity Log Reports",
    icon: "ft-clock",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
    hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
  },
  {
    path: "/contact-us",
    title: "Messages",
    icon: "ft-mail",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
    hasaccess: [CREATOR],
  },
  {
    path: "/resource-tutorial",
    title: "Resources & Tutorials",
    icon: "ft-book-open",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
    hasaccess: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED, RIGHT_HOLDER, RIGHT_HOLDER_TEAM],
  },
];
